//#region Icons
import ArrowIcon from 'icons/ArrowIcon';
//#endregion
//#region Styles
import {
    Container,
    DropdownButton
} from "./styles";
import Options from '../Options/Options';
//#endregion

const LogoutButton = ({
    openLogoutOptions
}) => {
    const getClassName = () => {
        const classList = [];
        openLogoutOptions.value && classList.push("opened");
        return classList.join(" ");
    }
    const className = getClassName();
    return (
        <Container>
            <DropdownButton 
                className={className}
                onClick={() => openLogoutOptions.set(!openLogoutOptions.value)}>
                <ArrowIcon/>
            </DropdownButton>
            <Options className={className}/>
        </Container>
    );
}

export default LogoutButton;